"use strict";

import { settingConstants, commonConstants } from "../_constants";

const INITIAL_SETTING_STATE = {
  changePasscodeSuccess: false,
  isAuthenticated: false,
  showAuthForm: true,
  notificationCategoryList: [],
  changePasswordSuccess: false,
  changePasscodeShow: false,
  isError: false,
  changePasscodeScreen: settingConstants.CURRENT_PASSWORD_SCREEN,
  changePasscode: {},
  changePassCodeOtpTimer: 0,
  isChangePasscodeApiCallFail: false,
  changePasscodeApiCallRequest: {},
  changeTwoFASuccess: false,
  isChangeTwoFAApiCallFail: false,
  twofaMethod: {
    customer: {},
    remainingTwoFaMethods: {},
    twoFactorMethod: null,
  },
  twofaMethodOtpFlow: {
    customer: {},
    otpTimerTimePeriod: null,
  },
};

export function setting(state = INITIAL_SETTING_STATE, action) {
  switch (action.type) {
    case settingConstants.SETTING_CHANGE_PASSCODE_COMPLETE:
      return {
        ...state,
        changePasscode: action.payload.data,
        changePassCodeOtpTimer: action.payload.data?.otpTimerTimePeriod,
      };

    case settingConstants.SETTING_CHANGE_PASSCODE_ERROR:
      return {
        ...state,
        changePasscode: action?.payload?.response?.errorDetails,
        changePassCodeOtpTimer:
          action?.payload?.response?.errorDetails?.remainingTime,
      };
    case settingConstants.SETTING_CHANGE_PASSCODE_OTP_RESEND_ERROR:
      return {
        ...state,
        changePassCodeOtpTimer:
          action?.payload?.response?.errorDetails?.remainingTime,
      }
    case settingConstants.SETTING_CHANGE_PASSCODE_OTP_CONFIRM_REQUEST:
      return {
        ...state,
        changePasscodeSuccess: false,
        isChangePasscodeApiCallFail: false,
        changePasscodeApiCallRequest: {},
      };
    case settingConstants.SETTING_CHANGE_PASSCODE_OTP_CONFIRM_COMPLETE:
      return {
        ...state,
        changePasscodeSuccess: true,
        changePasscode: {},
        changePassCodeOtpTimer: 0,
        isChangePasscodeApiCallFail: false,
        changePasscodeApiCallRequest: {},
      };
    case settingConstants.SETTING_CHANGE_PASSCODE_OTP_CONFIRM_ERROR:
      return {
        ...state,
        changePasscodeSuccess: false,
        isChangePasscodeApiCallFail: true,
        changePasscodeApiCallRequest: action.payload,
      };
    case settingConstants.ON_CLOSE_SETTING_CHANGE_PASSCODE_OTP_CONFIRM_RETRY:
      return {
        ...state,
        changePasscodeSuccess: false,
        isChangePasscodeApiCallFail: false,
        changePasscodeApiCallRequest: {},
      };
    case settingConstants.SETTING_CHANGE_PASSWORD_COMPLETE:
      return {
        ...state,
        changePasswordSuccess: true,
      };

    case settingConstants.SETTING_SHOW_AUTH_FORM:
      return {
        ...state,
        showAuthForm: action.payload,
      };

    case settingConstants.SETTING_AUTHENTICATE_COMPLETE:
      return {
        ...state,
        isAuthenticated: true,
        showAuthForm: false,
        changePasscodeShow: action.payload.data.isMobileBankingUser == "Y",
      };

    case settingConstants.SETTING_CHANGE_PASSCODE_VALIDATE_COMPLETE:
      return {
        ...state,
        changePasscodeScreen: settingConstants.ENTER_NEW_PASSWORD_SCREEN,
      };

    case settingConstants.SETTING_AUTHENTICATE_ERROR:
      return {
        ...state,
        isAuthenticated: false,
        showAuthForm: false,
        changePasscodeShow: false,
      };

    case settingConstants.SETTING_OTP_PREF_GET_TWOFA_METHOD_REQUEST:
      return {
        ...state,
        twofaMethod: {
          customer: {},
          remainingTwoFaMethods: {},
          twoFactorMethod: null,
        },
        changeTwoFASuccess: false,
        isChangeTwoFAApiCallFail: false,
      };

    case settingConstants.SETTING_OTP_PREF_GET_TWOFA_METHOD_COMPLETE:
      return {
        ...state,
        twofaMethod: {
          customer: action?.payload?.data?.customer,
          remainingTwoFaMethods: action?.payload?.data?.remainingTwoFaMethods,
          twoFactorMethod: action?.payload?.data?.twoFactorMethod,
        },
      };

    case settingConstants.SETTING_OTP_PREF_GET_TWOFA_METHOD_ERROR:
      return {
        ...state,
        twofaMethod: {
          customer: {},
          remainingTwoFaMethods: {},
          twoFactorMethod: null,
        },
      };

    case settingConstants.SETTING_OTP_PREF_GET_TWOFA_SEND_OTP_REQUEST:
      return {
        ...state,
        twofaMethodOtpFlow: {
          customer: {},
          otpTimerTimePeriod: null,
        },
        changeTwoFASuccess: false,
        isChangeTwoFAApiCallFail: false,
      };

    case settingConstants.SETTING_OTP_PREF_GET_TWOFA_SEND_OTP_COMPLETE:
      return {
        ...state,
        twofaMethodOtpFlow: {
          customer: action?.payload?.data?.customer,
          otpTimerTimePeriod: action?.payload?.data?.otpTimerTimePeriod,
        },
      };

    case settingConstants.SETTING_OTP_PREF_GET_TWOFA_SEND_OTP_ERROR:
      return {
        ...state,
        twofaMethodOtpFlow: {
          ...state.twofaMethodOtpFlow,
          customer: action?.payload?.response?.errorDetails?.customer,
          otpTimerTimePeriod:
            action?.payload?.response?.errorDetails?.remainingTime,
        },
      };

    case settingConstants.SETTING_OTP_PREF_GET_TWOFA_RESEND_OTP_REQUEST:
      return {
        ...state,
        twofaMethodOtpFlow: {
          ...state.twofaMethodOtpFlow,
          customer: action?.payload?.data?.customer,
          otpTimerTimePeriod: action?.payload?.data?.otpTimerTimePeriod,
        },
      };

    case settingConstants.SETTING_OTP_PREF_GET_TWOFA_RESEND_OTP_COMPLETE:
      return {
        ...state,
        twofaMethodOtpFlow: {
          ...state.twofaMethodOtpFlow,
          customer: action?.payload?.data?.customer,
          otpTimerTimePeriod: action?.payload?.data?.otpTimerTimePeriod,
        },
      };

    case settingConstants.SETTING_OTP_PREF_GET_TWOFA_RESEND_OTP_ERROR:
      return {
        ...state,
        twofaMethodOtpFlow: {
          ...state.twofaMethodOtpFlow,
          customer: action?.payload?.data?.customer,
          otpTimerTimePeriod:
            action?.payload?.response?.errorDetails?.remainingTime,
        },
      };

    case settingConstants.SETTING_OTP_PREF_GET_TWOFA_CONFORM_OTP_REQUEST:
      return {
        ...state,
        changeTwoFASuccess: false,
        isChangeTwoFAApiCallFail: false,
      };

    case settingConstants.SETTING_OTP_PREF_GET_TWOFA_CONFORM_OTP_COMPLETE:
      return {
        ...state,
        changeTwoFASuccess: true,
        isChangeTwoFAApiCallFail: false,
      };

    case settingConstants.SETTING_OTP_PREF_GET_TWOFA_CONFORM_OTP_ERROR:
      return {
        ...state,
        changeTwoFASuccess: false,
        isChangeTwoFAApiCallFail: true,
      };

    case settingConstants.ON_EXIT_SETTING_OTP_PREF_GET_TWOFA_CONFORM_OTP_RETRY:
      return {
        ...state,
        changeTwoFASuccess: false,
        isChangeTwoFAApiCallFail: false,
        twofaMethod: {
          customer: {},
          remainingTwoFaMethods: {},
          twoFactorMethod: null,
        },
        twofaMethodOtpFlow: {
          customer: {},
          otpTimerTimePeriod: null,
        },
      };

    case settingConstants.SETTING_GET_ALL_NOTIFICATION_CATEGORY_COMPLETE:
      return {
        ...state,
        notificationCategoryList: [...action.payload.data],
      };

    case settingConstants.SETTING_SET_INITIAL:
      return {
        ...state,
        changePasscodeSuccess: false,
        changePasswordSuccess: false,
        changePasscodeScreen: settingConstants.CURRENT_PASSWORD_SCREEN,
        isChangePasscodeApiCallFail: false,
        changePasscodeApiCallRequest: {},
      };
    case settingConstants.SETTING_SET_UNAUTHENTICATED:
      return {
        ...state,
        isAuthenticated: false,
        showAuthForm: true,
      };
    case settingConstants.CHANGE_PASSWORD_SET_SCREEN_TYPE:
      return {
        ...state,
        changePasscodeScreen: action.payload,
      };
  }

  return state;
}

const INITIAL_ACCOUNT_PREFERENCE_SETTINGS_STATE = {
  isAllAccountsLoading: false,
  allAccounts: {
    data: [],
  },
  isSavingAccountsLoading: false,
  allNotificationCategories: {
    data: [],
  },
  isNotificationCategoriesLoading: false,
  selectedAccount: {
    data: [],
  },
  updateStatus: settingConstants.SETTING_ACCOUNT_UPDATE_PENDING,
  allSavingAccountList: {
    data: [],
  },
  updateAccountStatus: [],
  setNickNameStatus: false,
};

export function settingAccountPreferences(
  state = INITIAL_ACCOUNT_PREFERENCE_SETTINGS_STATE,
  action,
) {
  switch (action.type) {
    case settingConstants.SETTING_GET_ALL_ACCOUNTS_REQUEST:
      return {
        ...state,
        isAllAccountsLoading: true,
      };
    case settingConstants.SETTING_GET_ALL_ACCOUNTS_ERROR:
      return {
        ...state,
        isAllAccountsLoading:
          action.type === settingConstants.SETTING_GET_ALL_ACCOUNTS_REQUEST,
        allAccounts: {
          data: [],
        },
      };

    case settingConstants.SETTING_GET_ALL_ACCOUNTS_COMPLETE:
      return {
        ...state,
        isAllAccountsLoading: false,
        allAccounts: {
          data: action?.payload?.data?.accountList,
        },
      };
    case settingConstants.SETTING_GET_ALL_ACCOUNTS_ERROR:
      return {
        ...state,
        isAllAccountsLoading: false,
        allAccounts: {
          data: [],
        },
      };
    case settingConstants.SETTING_GET_SELECTED_ACCOUNTS_COMPLETE:
      return {
        ...state,
        selectedAccount: {
          data: action?.payload?.data?.accountBasicData,
        },
      };
    case settingConstants.SETTING_CHANGE_OPERATING_TYPE_REQUEST:
      return {
        ...state,
        updateStatus: settingConstants.SETTING_ACCOUNT_UPDATE_PENDING,
      };
    case settingConstants.SETTING_CHANGE_OPERATING_TYPE_COMPLETE:
      return {
        ...state,
        updateStatus: settingConstants.SETTING_ACCOUNT_UPDATE_SUCCESS,
      };
    case settingConstants.SETTING_CHANGE_OPERATING_TYPE_ERROR:
      return {
        ...state,
        updateStatus: settingConstants.SETTING_ACCOUNT_UPDATE_FAIL,
      };
    case settingConstants.SETTING_CHANGE_OPERATING_TYPE_RESET:
      return {
        ...state,
        updateStatus: null,
      };

    case settingConstants.SETTING_GET_ALL_SAVING_ACCOUNTS_REQUEST:
      return {
        ...state,
        isSavingAccountsLoading: true,
        allSavingAccountList: {
          data: [],
        },
        updateAccountStatus: [],
      };
    case settingConstants.SETTING_GET_ALL_SAVING_ACCOUNTS_COMPLETE:
      return {
        ...state,
        isSavingAccountsLoading: false,
        allSavingAccountList: {
          data: action?.payload?.data?.accountList,
        },
        updateAccountStatus: [],
      };
    case settingConstants.SETTING_GET_ALL_SAVING_ACCOUNTS_ERROR:
      return {
        ...state,
        isSavingAccountsLoading: false,
        allSavingAccountList: {
          data: [],
        },
        updateAccountStatus: [],
      };
    case settingConstants.UPDATE_DEFAULT_ACCOUNT_REQUEST:
      return {
        ...state,
        updateAccountStatus: [],
      };
    case settingConstants.UPDATE_DEFAULT_ACCOUNT_COMPLETE:
      return {
        ...state,
        updateAccountStatus: commonConstants.STATUS_SUCCESS,
      };
    case settingConstants.RESET_DEFAULT_ACCOUNT_SETTING:
      return INITIAL_ACCOUNT_PREFERENCE_SETTINGS_STATE;
    case settingConstants.UPDATE_DEFAULT_ACCOUNT_ERROR:
      return {
        ...state,
      };
    case settingConstants.SETTING_GET_NOTIFICATION_CATEGORIES_REQUEST:
      return {
        ...state,
        isNotificationCategoriesLoading: true,
        allNotificationCategories: {
          data: [],
        },
      };
    case settingConstants.SETTING_GET_NOTIFICATION_CATEGORIES_COMPLETE:
      return {
        ...state,
        isNotificationCategoriesLoading: false,
        allNotificationCategories: {
          data: action?.payload?.data?.notificationCategoryList,
        },
      };
    case settingConstants.SETTING_GET_NOTIFICATION_CATEGORIES_ERROR:
      return {
        ...state,
        isNotificationCategoriesLoading: false,
        allNotificationCategories: {
          data: [],
        },
      };
    case settingConstants.UPDATE_NOTIFICATION_CATEGORY_REQUEST:
      return {
        ...state,
        updateAccountStatus: [],
      };
    case settingConstants.UPDATE_NOTIFICATION_CATEGORY_COMPLETE:
      return {
        ...state,
        updateAccountStatus: commonConstants.STATUS_SUCCESS,
      };
    case settingConstants.UPDATE_NOTIFICATION_CATEGORY_ERROR:
      return {
        ...state,
        updateAccountStatus: [],
      };
    case settingConstants.SET_ACCOUNT_NICKNAME_REQUEST:
      return {
        ...state,
        setNickNameStatus: false,
      };
    case settingConstants.SET_ACCOUNT_NICKNAME_COMPLETE:
      return {
        ...state,
        setNickNameStatus: commonConstants.STATUS_SUCCESS,
      };
    case settingConstants.SET_ACCOUNT_NICKNAME_ERROR:
      return {
        ...state,
      };

    case settingConstants.SET_ACCOUNT_NICKNAME_CLEAR_ALL:
      return {
        ...state,
        setNickNameStatus: false,
      };
  }

  return state;
}

const INITIAL_CREDIT_CARD_PREFERENCE_SETTINGS_STATE = {
  allCreditCards: {
    data: [],
  },
  updateStatus: settingConstants.SETTING_CREDIT_CARD_UPDATE_PENDING,
};

export function settingCreditCardPreferences(
  state = INITIAL_CREDIT_CARD_PREFERENCE_SETTINGS_STATE,
  action,
) {
  switch (action.type) {
    case settingConstants.SETTING_GET_ALL_CREDIT_CARD_PREF_REQUEST:
    case settingConstants.SETTING_GET_ALL_CREDIT_CARD_PREF_ERROR:
      return {
        ...state,
        allCreditCards: {
          data: [],
        },
      };
    case settingConstants.SETTING_GET_ALL_CREDIT_CARD_PREF_COMPLETE:
      return {
        ...state,
        allCreditCards: {
          data: action?.payload?.data?.accountDetails,
        },
      };
    case settingConstants.SETTING_CHANGE_CREDIT_CARD_OPERATING_TYPE_REQUEST:
      return {
        ...state,
        updateStatus: settingConstants.SETTING_CREDIT_CARD_UPDATE_PENDING,
      };
    case settingConstants.SETTING_CHANGE_CREDIT_CARD_OPERATING_TYPE_COMPLETE:
      return {
        ...state,
        updateStatus: settingConstants.SETTING_CREDIT_CARD_UPDATE_SUCCESS,
      };
    case settingConstants.SETTING_CHANGE_CREDIT_CARD_OPERATING_TYPE_ERROR:
      return {
        ...state,
        updateStatus: settingConstants.SETTING_CREDIT_CARD_UPDATE_FAIL,
      };
    case settingConstants.SETTING_CHANGE_OPERATING_TYPE_RESET:
      return {
        ...state,
        updateStatus: null,
      };
  }

  return state;
}

const INITIAL_SETTINGS_PROFILE_STATE = {
  profileData: {
    data: [],
  },
};

export function settingCustomerProfile(
  state = INITIAL_SETTINGS_PROFILE_STATE,
  action,
) {
  switch (action.type) {
    case settingConstants.SETTING_GET_CUSTOMER_PROFILE_DATA_COMPLETE:
      return {
        ...state,
        profileData: {
          data: action.payload.data.customer,
        },
      };
  }

  return state;
}
const INITIAL_SETTINGS_TRANSFER_LIMITS = {
  adminLimits: [],
  finalLimits: [],
  globalLimits: [],
  transferLimitScreenType: commonConstants.TRANSFER_LIMIT_INITIAL_SCREEN,
  selectedTransferType: null,
  addLimitStatus: [],
  isTransferLimitsLoading: false,
};

export function settingTransferLimits(
  state = INITIAL_SETTINGS_TRANSFER_LIMITS,
  action,
) {
  switch (action.type) {
    case settingConstants.SETTING_GET_TRANSFER_LIMITS_REQUEST:
      return {
        ...state,
        adminLimits: [],
        finalLimits: [],
        globalLimits: [],
        addLimitStatus: [],
        isTransferLimitsLoading: true,
      };
    case settingConstants.SETTING_GET_TRANSFER_LIMITS_COMPLETE:
      return {
        ...state,
        adminLimits: action?.payload?.data?.adminLimits,
        finalLimits: action?.payload?.data?.finalLimits,
        globalLimits: action?.payload?.data?.globalLimits,
        addLimitStatus: [],
        isTransferLimitsLoading: false,
      };

    case settingConstants.SETTING_GET_TRANSFER_LIMITS_ERROR:
      return {
        ...state,
        adminLimits: [],
        finalLimits: [],
        globalLimits: [],
        addLimitStatus: [],
        isTransferLimitsLoading: false,
      };

    case settingConstants.SETTING_ADD_TRANSFER_LIMIT_REQUEST:
      return {
        ...state,
        addLimitStatus: [],
        changeLimits: action.payload,
      };
    case settingConstants.SETTING_ADD_TRANSFER_LIMIT_COMPLETE:
      return {
        ...state,
        addLimitStatus: commonConstants.STATUS_SUCCESS,
      };

    case settingConstants.RESET_TRANSFER_LIMIT_SETTING:
      return INITIAL_SETTINGS_TRANSFER_LIMITS;

    case settingConstants.TRANSFER_LIMITS_SET_SCREEN_TYPE:
      return {
        ...state,
        transferLimitScreenType: action.payload,
      };
    case settingConstants.SELECTED_TRANSFER_TYPE:
      return {
        ...state,
        selectedTransferType: action.payload,
      };
    case settingConstants.CLEAR_TRANSFER_LIMITS:
      return INITIAL_SETTINGS_TRANSFER_LIMITS;
  }

  return state;
}
